'use client';

import { PropsWithChildren, useEffect, useState } from 'react';

const ClientHydration = ({ children }: PropsWithChildren) => {
  const [render, setRender] = useState(false);
  useEffect(() => setRender(true), []);

  return render ? <>{children}</> : null;
};

export default ClientHydration;
